import fetchMerchandiseBrands from 'actions/merchandise/fetchMerchandiseBrands'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

interface Options {
  disabled?: boolean
}

type ReturnType = [
  App.MerchandiseBrand | undefined,
  boolean,
  any,
]

function useMerchandiseBrand(id?: string, options: Options = {}): ReturnType {
  const dispatch = useAppDispatch()

  const brandData = useAppSelector(state => state.merchandise.merchandiseBrands)

  useEffect(() => {
    if (!options.disabled) {
      dispatch(fetchMerchandiseBrands())
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [options.disabled])

  return [
    id ? brandData?.brands?.[id] : undefined,
    brandData?.fetching ?? false,
    brandData?.error,
  ]
}

export default useMerchandiseBrand
